<template>
  <action-log-template :actionLog="actionLog">
    <template #actionName>
      <p :class="['action-type flex-row flex__left inline-flex']">
        <i
          :class="['font-size__small', 'fal fa-check-circle', 'color__blue']"
        ></i>
        <span class="font-size__small no_wrap color__blue">
          &nbsp;{{ actionNameLabel || "-" }}
        </span>
      </p>
      &nbsp; từ ngày &nbsp;
      <span class="color__blue font-italic">
        {{
          previousDeadline
            | dateFormatter({
            nullValue: "-",
            dateFormat: "DD/MM/YYYY"
          })
        }}
      </span>
      &nbsp; đến ngày &nbsp;
      <span class="color__blue font-italic">
        {{
          nextDeadline
            | dateFormatter({
            nullValue: "-",
            dateFormat: "DD/MM/YYYY"
          })
        }}
      </span>
    </template>
  </action-log-template>
</template>

<script>
import convertToLabelFilter from "../../../filters/convertToLabelFilter";
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import ActionLogTemplate from "./action-log-template";
import dateFormatter from "../../../filters/dateFormatter";

export default {
  name: "hc-commands-gia-han-action-log",
  components: {ActionLogTemplate},
  props: ["actionLog"],
  filters: {
    convertToLabelFilter,
    dateFormatter
  },
  data() {
    return {
      actionNameLabel: null,
      dataJson: null,
      previousDeadline: null,
      nextDeadline: null
    };
  },
  created() {
    this.actionNameLabel = hanhChinhUtils.getActionLogActionNameLabel(
      this.actionLog.actionName
    );
    this.dataJson = JSON.parse(this.actionLog.dataJson);
    this.previousDeadline = this.dataJson.previousDeadline;
    this.nextDeadline = this.dataJson.nextDeadline;
  },
  methods: {}
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/ketluan/hc-commands-gia-han-action-log.vue